// extracted by mini-css-extract-plugin
export var container = "_60-0";
export var infoButton = "_60-1";
export var label = "_60-3";
export var labelExpanded = "_60-4";
export var price = "_60-5";
export var priceExpanded = "_60-6";
export var title = "_60-2";